module.exports = __webpack_public_path__ + "img/explore.2f19ec9f.svg";